var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "100%",
      "max-width": "720",
      "content-class": "rounded-lg"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', {
    staticClass: "full-height"
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [_c('bottom-sheet-header', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(" 성차별금지 주요내용 "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": "",
      "absolute": "",
      "right": "",
      "color": "white"
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-sheet', {
    staticClass: "scroll-primary py-40 px-60",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text mb-12 mb-lg-20"
  }, [_vm._v(" 모집·채용에서 남녀를 차별하거나, 여성근로자를 채용할 때 직무수행에 불필요한 용모, 키, 체중 등의 신체조건, 미혼조건을 제시 또는 요구하는 경우는 남녀고용평등과 일·가정 양립 지원에 관한 법률 위반에 따른 500만원 이하의 벌금이 부과될 수 있습니다. ")]), _c('vertical-table', _vm._b({}, 'vertical-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "차별사례"
  }, [_c('ul', [_c('li', {
    staticClass: "mb-4"
  }, [_vm._v("· 특정성을 지칭하는 직종명 등 사용하는 경우, 특정성 배제"), _c('br'), _vm._v("남성 선반공, 병역필 남, 여성 비서, 미용사(여성 환영) 등")]), _c('li', [_vm._v("· 직종 등 남녀 분리모집 등"), _c('br'), _vm._v("관리ㆍ사무직 남성 10명, 판매직 여성 5명")])])]), _c('template', {
    slot: "차별로 보지 않는 사례"
  }, [_c('ul', [_c('li', {
    staticClass: "mb-4"
  }, [_vm._v("· 직무성질상 특정한 성이 불가피한 경우"), _c('br'), _vm._v("남성역할 위한 배우ㆍ모델 등"), _c('br'), _vm._v("여성 목욕탕의 여성 목욕관리사, 여성 장애인ㆍ여성 환자의 도우미 등"), _c('br'), _vm._v("여성 기숙사의 여성사감 등")]), _c('li', [_vm._v("· 현존하는 차별 없애거나 고용평등 촉진위해 잠정적으로 특정성 우대하는 조치를 하는 경우 등")])])])], 2)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }